import { gql } from '@apollo/client';

export const GET_POOLING_GROUP_CAPACITY = gql`
  query GetPoolingGroupCapacity($poolingGroupId: String!) {
    getPoolingGroupCapacity(poolingGroupId: $poolingGroupId) {
      free
    }
  }
`;
